import { FC } from "react";
import { t } from "@lingui/macro";
import cx from "classnames";

import PageTitle from "../../PageTitle/PageTitle";
import TotalTradingVolume from "./components/TotalTradingVolume";

import s from "./PhaseFour.module.scss";
import TradeCard from "./components/TradeCard";
import StatisticsBlock from "./components/StatisticsBlock";
import DepositCard from "./components/DepositCard";
import { Item } from "../TMXPhaseCard/TMXPhaseCard";

type Props = {
  item: Item;
};

const PhaseFour: FC<Props> = ({ item }) => {
  return (
    <>
      <PageTitle
        title={t`${item.title}`}
        qa="launch-page"
        showNetworkIcon={false}
        className="mb-[2rem] mt-[4rem] lg:mb-[4rem] lg:mt-[8rem] xl:mb-[7rem] xl:mt-[14rem]"
        isTop={true}
      />

      <div className={cx("DashboardV2-cards", s.phaseFourCardContainer)}>
        <div className={s.leftBlock}>
          <TotalTradingVolume item={item} />
          {/*<StatisticsBlock />*/}
        </div>
        {/*<div className={s.rightBlock}>*/}
        {/*  <TradeCard />*/}
        {/*  <DepositCard />*/}
        {/*</div>*/}
      </div>
    </>
  );
};

export default PhaseFour;
